import { ref } from "@vue/composition-api"
import { shopsUseCase } from "../../usecases"

const useShops = () => {
    const data = ref({})
    const getShopData = async (id) => {
        data.value = await shopsUseCase.getShopById(id)
    }
    return {
        data,
        getShopData,
    }
}

export default useShops